// 定义Modal组件的类型
import React, {useContext, useEffect} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import CustomPopup from "../../../../components/CustomPopup";
import '../../../../global/css/global-display.css'
import '../../../../global/css/container.css'
import './DownloadDialog.css'
import {APP_DOWNLOAD_URL} from "../../../../common/config/config.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";

type SettingModalProps = {
    isOpen: boolean;
    onClose: () => void;
};
const DownloadDialog: React.FC<SettingModalProps> = ({isOpen, onClose,}) => {
    // // music 管理器
    // const musicManager = useMusicContext();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    useEffect(() => {
        if (isOpen) {
            // GA埋点
            GAEvents.downloadPopupShow();
        }
    }, [isOpen]);

    // 跳转到下载页面
    const toDownloadPage = (type: string) => {
        // GA埋点
        GAEvents.downloadPopupClickDownloadButton(type);
        window.open(APP_DOWNLOAD_URL, '_blank');
    };

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="download-modal-container">
                <div className="login-background-color border-radius-10"/>
                <div className="common-page-background-img border-radius-10"
                     style={{backgroundImage: `url(${imgUrls.rectangleIcon})`, backgroundSize: '60px 60px'}}/>
                <div className="login-background-color-white border-radius-10"/>
                {/*标题*/}
                <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                     alt="关闭"/>
                <img className="width-60 height-60 margin-left-right-auto margin-top-32" src={imgUrls.logoImgUrl}
                     alt="pic"/>
                <img className="width-180 margin-left-right-auto margin-top-20" src={imgUrls.logoTextImgUrl} alt="pic"/>
                <div className="margin-top-20 font-size-16 my-roboto-regular text-center">For better experience please
                </div>
                <div className="margin-top- font-size-16 my-roboto-regular text-center">download CGTN APP</div>
                {/*按钮*/}
                <div onClick={() => toDownloadPage('iPhone')} className="download-button-container margin-top-20">
                    <div><img className="phone-icon" src={imgUrls.appleIconUrl} alt="pic"/></div>
                    <div className="font-size-16 color-blue my-roboto-medium">iPhone</div>
                </div>
                <div onClick={() => toDownloadPage('Android')}
                     className="download-button-container margin-top-11 margin-bottom-20">
                    <div><img className="phone-icon" src={imgUrls.androidIconUrl} alt="pic"/></div>
                    <div className="font-size-16 color-blue my-roboto-medium">Android</div>
                </div>
            </div>
        </CustomPopup>
    );
};

export default DownloadDialog;